module.exports = __webpack_public_path__ + "static/media/profile_photo.2deaf52c.png";